/**
 * Используются для динамического иморта карты на страницу
 * @example
 * Есть два способа использование: Оба способа после инициализации записывает в window.Block.AboutCompanyB2b конструктор
 * 1. Получение через then
 *	window.ImportBlock.AboutCompanyB2b().then((AboutCompanyB2b) => {
 *		new AboutCompanyB2b(...);
 *	})
 * 2. Через await (требуется обёртка в async функцию)
 * 	const AboutCompanyB2b = await window.ImportBlock.AboutCompanyB2b();
 * 	new AboutCompanyB2b(...);
 * @return {Promise<AboutCompanyB2b>} - Возвращает импортируемый класс если есть хотя бы одна карта на странице
 */
window.ImportBlock.AboutCompanyB2b = async () => {
	const item = document.querySelector('.about-company-b2b:not(.about-company-b2b_inited)');
	if (item) {
		const { AboutCompanyB2b } = await import(/* webpackChunkName: "AboutCompanyB2b" */ './about-company-b2b.module');
		window.Block.AboutCompanyB2b = AboutCompanyB2b;
		return AboutCompanyB2b;
	}
};

if (NOT_PROD) {
	window.ImportBlock.AboutCompanyB2b().then((AboutCompanyB2b) => {
		AboutCompanyB2b?.init();
	});
}
